<template>
  <a-empty v-show="opt.isEmpty" v-bind="opt" />
</template>

<script>
export default {
  data() {
    return {
      opt:{ }
    }
  }
}
</script>
